export function redirectToWalletSignin(walletUrl: string) {
  const redirectBackUrl = encodeURIComponent(
    `${window.location.origin}/auth?redirect=${encodeURIComponent('/trade')}`
  )
  const redirectUrl = `${walletUrl}/#/login?product=exchange&redirect=${redirectBackUrl}`
  window.location.href = redirectUrl
}

export function redirectToWalletSignup(walletUrl: string, passedParams?: Record<string, string>) {
  const params = passedParams ?? {}
  const extraParams = Object.keys(params).reduce(
    (str, key) => `${str}&${key}=${encodeURIComponent(params[key])}`,
    ''
  )
  const redirectUrl = `${walletUrl}/#/signup?product=exchange&${extraParams}`
  window.location.href = redirectUrl
}

type SettingsRedirectRequest = {
  email: string
  settingsSection: 'password' | '2fa' | 'email'
  walletGuid: string
  walletUrl: string
}
export function redirectToWalletSettings({
  email,
  settingsSection,
  walletGuid,
  walletUrl
}: SettingsRedirectRequest) {
  const redirectUrl = `${walletUrl}/#/open/settings?change=${encodeURIComponent(
    settingsSection
  )}&guid=${encodeURIComponent(walletGuid)}&email=${encodeURIComponent(email)}`
  window.location.href = redirectUrl
}

export const getWalletLoginUrl = (walletUrl: string, walletGuid: string, email: string) =>
  `${walletUrl}#/login?product=wallet&guid=${encodeURIComponent(
    walletGuid
  )}&email=${encodeURIComponent(email)}`
